import { render, staticRenderFns } from "./UiSpinnerWave.vue?vue&type=template&id=2b1624d9&scoped=true&"
import script from "./UiSpinnerWave.vue?vue&type=script&lang=js&"
export * from "./UiSpinnerWave.vue?vue&type=script&lang=js&"
import style0 from "./UiSpinnerWave.vue?vue&type=style&index=0&id=2b1624d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1624d9",
  null
  
)

export default component.exports